// import React, { useState } from "react";
import { Clock, Mail, MapPin } from "lucide-react";
import Wave from "react-wavify";

const Contact: React.FC = () => {
    // const [isOpen, setIsOpen] = useState(false);

    return (
        <div id="reserveer" className="bg-[#9a3415]">
            <div>
                <div id="contact" className={"bg[#d0d4b4]"}>
                    <Wave fill='#f8f6e3'
                          paused={true}
                          style={{display: 'flex'}}
                          options={{
                              height: 70,
                              amplitude: 50,
                              speed: 0.15,
                              points: 3
                          }}
                    />
                </div>
            </div>
            <div className="bg-background">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="">
                        <div className="md:w-1/2 m-auto">
                            <h1 className={"font-black text-5xl text-center text-[#9a3415]"}>Contact</h1>
                        </div>
                        <div className="grid md:grid-cols-2 grid-cols-1 gap-6 px-4 py-8">
                            {/* Openingsuren Card */}
                            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md hover:shadow-lg transition-shadow">
                                <div className="flex items-center gap-3 mb-4">
                                        <Clock size={24} className="text-[#9a3415] md:h-7 md:w-7" />
                                        <h5 className="font-bold text-lg md:text-xl text-[#9a3415]">Openingsuren</h5>
                                    </div>
                                <div className="space-y-3">
                                    {[
                                        { day: 'Maandag', hours: '09:00 - 15:00' },
                                        { day: 'Dinsdag', hours: 'Gesloten' },
                                        { day: 'Woensdag', hours: 'Gesloten' },
                                        { day: 'Donderdag', hours: 'Gesloten' },
                                        { day: 'Vrijdag', hours: '09:00 - 16:00' },
                                        { day: 'Zaterdag', hours: '09:00 - 16:00' },
                                        { day: 'Zondag', hours: '09:00 - 16:00' }
                                    ].map((item, idx) => (
                                        <div key={idx} className="flex justify-between items-start md:items-center pb-2 border-b border-gray-100 last:border-b-0 gap-2">
                                            <span className="text-gray-700 font-medium text-sm md:text-base flex-shrink-0">{item.day}</span>
                                            <span className={`font-semibold text-sm md:text-base text-right ${item.hours === 'Gesloten' || item.hours === '1ste woensdag open' ? 'text-gray-400' : 'text-[#9a3415]'}`}>
                                                {item.hours}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Contact Info Cards */}
                            <div className="space-y-6">
                                {/* Email Card */}
                                <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow">
                                    <div className="flex items-center gap-3 mb-3">
                                        <Mail size={28} className="text-[#9a3415]" />
                                        <h5 className="font-bold text-xl text-[#9a3415]">E-mail</h5>
                                    </div>
                                    <p className="text-gray-700 text-lg">contact@bar-elvire.be</p>
                                </div>

                                {/* Address Card */}
                                <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow">
                                    <div className="flex items-center gap-3 mb-3">
                                        <MapPin size={28} className="text-[#9a3415]" />
                                        <h5 className="font-bold text-xl text-[#9a3415]">Adres</h5>
                                    </div>
                                    <p className="text-gray-700 text-lg">Gemeenteplein 22<br />2820 Rijmenam, België</p>
                                </div>
                            </div>

                        </div>
                        <div className={"rounded-xl "}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d627.6937030279743!2d4.584088348212023!3d51.00183329310764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3e181fabde14f%3A0x7cc409d71cf8b4f3!2sGemeenteplein%2022%2C%202820%20Bonheiden%2C%20Belgium!5e0!3m2!1sen!2sus!4v1714671474793!5m2!1sen!2sus"
                                title="Insluiting van een interactieve kaart"
                                height={300}
                                className={"w-full rounded-xl"}
                                allowFullScreen={false} loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Contact;
